import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import MarketplaceAdminPayoutReportPdf from "./marketplaceAdminPayoutReportPdf";
import apiCalls from "../utils/apiCalls";
import utils from "../utils/utils";

const MarketplaceAdminPayoutReportView = ({payoutReports, match}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    apiCalls.getOrders({
      payoutReportId: match.params.payoutReportId,
    }).then((result) => {
      setOrders(result.data.orders);
      setLoading(false);
    }).catch((errors) => {
      setError(utils.getErrorMessageFromResponse(errors));
      setLoading(false);
    });
  }, []);

  const payoutReport = payoutReports
    .find(payoutReport => payoutReport.id.toString() === match.params.payoutReportId);

  if (!payoutReport || orders.length === 0) {
    return '';
  }

  return (
    <div className="marketplace-admin__payout-report">
      <MarketplaceAdminPayoutReportPdf payoutReport={payoutReport} orders={orders}/>
    </div>
  );
}

MarketplaceAdminPayoutReportView.propTypes = {
  payoutReports: PropTypes.array.isRequired,
};

MarketplaceAdminPayoutReportView.defaultProps = {};

export default MarketplaceAdminPayoutReportView;